module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (128).ed669ed9.jpg";